import { render, staticRenderFns } from "./ShowFiled.vue?vue&type=template&id=ae897132&scoped=true&"
import script from "./ShowFiled.vue?vue&type=script&lang=js&"
export * from "./ShowFiled.vue?vue&type=script&lang=js&"
import style0 from "./ShowFiled.vue?vue&type=style&index=0&id=ae897132&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae897132",
  null
  
)

export default component.exports